'use strict';

import { ReanimatedError } from "./errors.js";
export function getShadowNodeWrapperFromRef() {
  throw new ReanimatedError('Trying to call `getShadowNodeWrapperFromRef` on web.');
}
//# sourceMappingURL=fabricUtils.web.js.map